import React, { Component } from "react";
import Checkbox from "./icons/checkbox";
import Arrow from "./icons/arrows";
import block from "bem-cn-lite";

const b = block("RequestFormsInput");

class Option extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false
        };
    }
    mouseenter() {
        this.setState({ hover: true });
    }
    mouseleave() {
        this.setState({ hover: false });
    }
    render() {
        const {name, value, chosen, onClick} = this.props;
        const {hover} = this.state;
        return <div
            onClick={e => {e.stopPropagation(); onClick({name, value})}}
            onMouseEnter={() => this.mouseenter()}
            onMouseLeave={() => this.mouseleave()}
            className={b("option", {
                active: chosen && chosen.name === name
            })}
            key={value}
        >
            <Checkbox
                className={b("checkbox")}
                checked={chosen && chosen.name === name}
                hover={hover}
            />
            {name}
        </div>;
    }
}

export default class Select extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            chosen: null
        };
        this.chooseOption = this.chooseOption.bind(this)
    }
    toggle() {
        this.setState({ isOpen: !this.state.isOpen });
    }
    chooseOption(option) {
        this.props.onChange && this.props.onChange(option);
        this.setState({ chosen: option, isOpen: false });
    }
    componentDidMount() {
        document.body.addEventListener('click', () => this.setState({isOpen: false}))
    }
    render() {
        const { options, placeholder, invalid} = this.props;
        const { chosen, isOpen } = this.state;

        return (
            <div tabIndex="0" className={b({invalid})} onClick={(e) => {this.toggle()}}>
                <div className={b("current")}>
                    {chosen && chosen.name ? chosen.name : placeholder}
                    <Arrow />
                </div>
                <div
                    className={b("dropdown")}
                    style={{ display: isOpen ? "block" : "none" }}
                >
                    {options.map(option => <Option 
                        onClick={this.chooseOption}
                        chosen={chosen} {...option}
                        key={option.value}
                        />)}
                </div>
            </div>
        );
    }
}
